import type {RichTextField} from '@prismicio/client'

const NON_ALPHANUMERIC_REGEX = /[^a-z0-9 -]/gi
const SEPARATOR_RUN_REGEX = /[\s-]+/g
const EDGE_HYPHENS_REGEX = /^-+|-+$/g

/**
 * Turns a heading into a URL fragment: lowercase, with every run of spaces and hyphens
 * collapsed into a single hyphen.
 *
 * Symbols are stripped before the spaces are hyphenated, so `Cost & Savings` yields
 * `cost-savings` rather than leaving an empty segment behind.
 *
 * @param str - The heading text
 * @returns The anchor slug
 */
export const removeNonAlphanumeric = (str: string) =>
  str
    .toLowerCase()
    .replace(NON_ALPHANUMERIC_REGEX, '')
    .replace(SEPARATOR_RUN_REGEX, '-')
    .replace(EDGE_HYPHENS_REGEX, '')

/**
 * Extracts the plain text of every heading 2 in a rich text field, in document order.
 * Used to build the table of contents, which links to the `h2[id]` anchors rendered from them.
 *
 * @param content - The rich text field to scan
 * @returns The text of each heading 2 node
 */
export const getHeading2Texts = (content: RichTextField): string[] =>
  content.flatMap((node) => (node.type === 'heading2' ? [node.text] : []))
